<header class="header">
    <div class="container d-flex justify-content-between align-items-center">
        <div class="logo">
            <img src="assets/images/backgrounds/trs.png" alt="Logo" class="logo-img" />
        </div>
        <div class="contact-info d-flex justify-content-center align-items-center">
            <p class="contact-item">
                <i-tabler name="mail" class="icon-20 m-r-4"></i-tabler>
                <a href="mailto:inquiry.shivtrading&#64;gmail.com" class="linkdeco" target="_blank" rel="noopener noreferrer">
                    inquiry.shivtrading&#64;gmail.com
                </a>
            </p>
            <p class="contact-item">
                <i-tabler name="phone" class="icon-20 m-r-4"></i-tabler>
                <a href="tel:+917359408000" target="_blank" class="linkdeco" rel="noopener noreferrer">
                    +91 7359408000
                </a>
            </p>
            <p class="contact-item">
                <i-tabler name="brand-whatsapp" class="icon-20 m-r-4"></i-tabler>
                <a href="https://wa.me/917359508000" class="linkdeco" target="_blank" rel="noopener noreferrer">
                    +91 7359508000
                </a>
            </p>
        </div>
    </div>
</header>

  
<div class="extraspace"></div>

<section class="inner-section about-company" style="background-color: #fdf5e6;">
  <div class="container">
      <div class="row align-items-center">
          <div class="col-lg-6">
              <div class="about-content">
                  <h4 class="title1">About Us</h4>
                  <h2 class="title2">Shiv Trading</h2>
                  <p class="pera">
                    <b>Shiv Trading</b> is a leader in the edible oil industry, dedicated to delivering a diverse range of high-quality oils that meet the varied needs of our customers. <br>
                    With years of experience and a commitment to innovation, we continually upgrade our technology and machinery to ensure top-quality production.<br>
                     Our expertise and ongoing process enhancements have earned us a trusted reputation in the market, allowing us to consistently maintain our position as a frontrunner in the edible oil sector.
                  </p>
              </div>
          </div>
          <div class="col-lg-6">
              <div class="about-img"><img src="assets/images/backgrounds/1p.png" alt="about" /></div>
          </div>
      </div>
  </div>
</section>

<section class="product-section">
  <div class="container-pro">
      <h2 class="heading">Find Your Oil</h2>
      <div class="row">
          @for(product of dashboardCollectionList; track product.pro_id) {
          <div class="col-md-3 product-card">
              <a href="https://play.google.com/store/apps/details?id=com.iss.shivtrading" target="_blank">
                  <div class="card">
                      <div class="card-img">
                          <img [src]="product.pro_image" alt="{{ product.pro_name }}" class="product-img" />
                      </div>
                      <div class="card-body">
                          <span class="bg-light-error text-accent border-error rounded f-w-600 p-6 p-y-4 f-s-12 unit-badge">{{ product.unit_name }} {{ product.unit_name_bill }}</span>
                          <h4 class="product-name">{{ product.pro_name }}</h4>
                      </div>
                  </div>
              </a>
          </div>
          }
      </div>
  </div>
</section>

<footer class="footer">
    <p>
      Copyright © 2024 Shivtrading, All rights reserved | Developed By 
      <a href="https://invisionsoftwaresolution.in/" target="_blank" class="linkdeco">Invision Software Solutions | </a>
      <a href="/authentication/privacypolicy" target="_blank" class="linkdeco">Privacy Policy | </a>
      <a href="/authentication/termscondition" target="_blank" class="linkdeco">Tearms & Conditions</a>
    </p>
  </footer>
  
